import { useQuery } from '@tanstack/react-query';
import { getContactRoles } from '../api/contacts';

export function useContactRoles() {
  return useQuery({
    queryKey: ['contact-roles'],
    queryFn: getContactRoles,
    staleTime: 5 * 60 * 1000,
  });
}
